import { CoreInitiativesLinksByIdName } from './name';
import { coreInitiativesLinksUpdateSyncSlice } from '../update';
import { createPatchAsyncSlice } from '@sonar-software/xuder';
import { patchInitiativeLink } from '@api';

export const coreInitiativesLinksByIdPatchAsyncSlice = createPatchAsyncSlice({
	httpSagaOptions: {
		successCombinationActionCreators: [ coreInitiativesLinksUpdateSyncSlice.syncActionCreator ]
	},
	name: CoreInitiativesLinksByIdName,
	receive: false,
	request: true,
	requestHandler: patchInitiativeLink
});
